<div
    *ngIf="loading && isActive"
    [agprLoading]="loading"
    class="agpr-loadingOverlay"
>
</div>
<div
    [style.display]="selected ? '' : 'none'"
    role="tabpanel"
    [id]="id + '.panel'"
    [attr.aria-labelledby]="id"
    >
    <ng-template #tabHeader>
        @if (!hideBusinessCard) {
            <agpr-entity-business-card
                [id]="id + '_affiliatesBusinessCard'"
                [isRHP]="true"
                [canOpenFullProfile]="false"
                [entity]="selectedOutlet"
                [outletPrivateData]="outletPrivateData"
                [isCondensedMode]="true"
            ></agpr-entity-business-card>
        }
        <!-- top row -->
        <div
            class="agpr-affiliates-filterToolbar"
            [@toolbarCollapsed]="toolbarStateService.toolbarCollapsed && !toolbarStateService.toolbarAnimationDisabled"
            (@toolbarCollapsed.start)="onAnimationStart($event)"
            (@toolbarCollapsed.done)="onAnimationDone($event)"
        >
            <div
                class="agpr-affiliates-filterToolbar-wrapper"
                [ngClass]="{'agpr-affiliates-filterToolbar-wrapper--chips': chipsVisible}"
            >
                <agpr-filter-dropdown
                    [id]="id + 'resultsFilters'"
                    [showQuickFilter]="true"
                    quickFilterPlaceholder="Discover.targeting.filter.quick.contactName.placeholder"
                    [ariaLabel]="'Discover.targeting.filter.outletAffiliates' | localize"
                    [ariaDescribedBy]="id + 'filter.chips'"
                    class="agpr-affiliates-filterToolbar-filterInput"
                >
                </agpr-filter-dropdown>
                <agpr-sort-order
                    [id]="id + '_affiliates-sortOrder'"
                    class="agpr-affiliates-filterToolbar-sortOrder"
                    [isDisabled]="!total"
                    tooltip="Discover.targeting.tooltips.sort"
                    optionKey="enumValue"
                    optionLabel="displayString"
                ></agpr-sort-order>
            </div>
            @if (chipsVisible) {
                <agpr-filter-chips
                    [id]="id + 'filter.chips'"
                    class="agpr-affiliates-filterChips"
                ></agpr-filter-chips>
            }
        </div>

        <!-- second row -->
        <div
            class="agpr-targetingResults-listBuilder-rhp"
            [@toolbarCollapsed]="toolbarStateService.toolbarCollapsed && !toolbarStateService.toolbarAnimationDisabled"
            (@toolbarCollapsed.start)="onAnimationStart($event)"
            (@toolbarCollapsed.done)="onAnimationDone($event)"
        >
            <agpr-autocomplete
                #listBuilderDropdown
                [id]="id + '.listBuilderDropdown'"
                labelField="name"
                placeholder="Discover.listBuilder.widget.placeholder.dropdown"
                [dropdown]="true"
                dropdownMode="current"
                [(ngModel)]="selectedLists"
                [customOptions]="listBuilderOptions"
                (itemSelected)="updateListBuilder()"
                [suggestions]="targetingLists$"
                [multiSelection]="true"
                [pTooltip]="'Discover.listBuilder.widget.tooltip.dropdown' | localize"
                tooltipPosition="top"
                ariaLabel="Discover.listBuilder.widget.placeholder.dropdown"
                [showHiddenOption]="true"
            ></agpr-autocomplete>
            <span class="agpr-targetingResults-listBuilder-lock">
                <agpr-button
                    [ngClass]="{
                        'agpr-targetingResults-toolbarIcon--lock': workingListsLocked,
                        'agpr-targetingResults-toolbarIcon--unlock': !workingListsLocked
                    }"
                    [style]="buttonTypes.icon"
                    [id]="id + '.listBuilder.lock'"
                    (click)="listPickerService.toggleWorkingListsLock()"
                    [icon]="workingListsLocked ? 'fa-regular fa-duotone fa-lock' : 'fa-regular fa-duotone fa-unlock'"
                    [tooltip]="workingListsLocked ? 'Discover.listBuilder.widget.tooltip.unlock' : 'Discover.listBuilder.widget.tooltip.lock'"
                    tooltipPosition="top"
                ></agpr-button>
            </span>
            <agpr-button
                class="agpr-targetingResults-listBuilder-addToListButton agpr-affiliates-listBuilder-addToListButton"
                [id]="id + '.addToList'"
                [style]="buttonTypes.icon"
                icon="fa-regular fa-duotone fa-user-plus"
                [disabled]="!total || selectedResults.length === 0"
                (click)="addToList()"
                tooltip="Discover.listBuilder.widget.tooltip.addButton"
                tooltipPosition="left"
            ></agpr-button>
        </div>

        <!-- third row -->
        <div
            class="agpr-targetingResults-listBuilder-rhp-chipContainer"
            *ngIf="selectedListsChips?.length"
            [@toolbarCollapsed]="toolbarStateService.toolbarCollapsed && !toolbarStateService.toolbarAnimationDisabled"
            (@toolbarCollapsed.start)="onAnimationStart($event)"
            (@toolbarCollapsed.done)="onAnimationDone($event)"
        >
            <agpr-chip-container
                #listChipsComponent
                [id]="id + '.selectedLists.chips'"
                [chips]="selectedListsChips"
                (removeChip)="listPickerService.removeWorkingListByIndex($event)"
            ></agpr-chip-container>
            <agpr-button
                *ngIf="selectedLists.length > 1"
                class="agpr-targetingResults-toolbarIcon-clear"
                [style]="buttonTypes.link"
                id="listBuilderClear"
                (click)="clearListChips()"
                icon="agpr-i-clear"
                tooltip="Discover.listBuilder.widget.tooltip.clearAll"
                tooltipPosition="top"
            ></agpr-button>
        </div>

        <!-- bottom row -->
        <div
            class="agpr-affiliates-selectBar agpr-affiliates-selectBar-Container"
            [style.width]="toolbarStateService.toolbarCollapsed ? toolbarStateService.toolbarWidth + 'px' : '100%'"
        >
            <agpr-checkbox
                [id]="id + '_targetingResult_affiliatesService_selectAll'"
                [binary]="true"
                [disabled]="!total"
                hiddenLabel="selectAll"
                [ngModel]="results?.length > 0 && selectedResults?.length >= results?.length"
                (ngModelChange)="toggleSelectAll()"
            >
                <span class="agpr-affiliates-selectBar-totalCount-value">
                    {{ allSelected ? total : (selectedResults?.length || '0') }}
                    <span class="agpr-affiliates-selectBar-totalCount-text">
                        {{ 'Paginator.of' | localize }}
                        <span class="agpr-affiliates-selectBar-totalCount-value">
                            {{ total || '0'}}
                        </span>
                        {{'Paginator.selected' | localize}}
                    </span>
                </span>
            </agpr-checkbox>
            <agpr-minimal-paginator [isDisabled]="!total"></agpr-minimal-paginator>
        </div>
    </ng-template>
    <ng-container *ngIf="organizedResults">
        <ng-container *ngFor="let outletGroup of organizedResults; let i = index">
            <div
                [id]="id + '_affiliatesGroup_' + i"
                class="agpr-affiliates-productTypeLabel"
            >
                {{outletGroup.label | localize}}
            </div>
            <ul
                [id]="id + '_affiliatesList'"
                [attr.aria-labelledby]="id + '_affiliatesGroup_' + i"
                agprListKeyboardNavigation
                [focusOnChild]="true"
                [list]="outletGroup.outlets"
                focusableElementCustomSelector=".agpr-targetingResults-card"
            >
                <li *ngFor="let outlet of outletGroup.outlets; let j = index">
                    <agpr-affiliate-card
                        [id]="i + '.' + j + '.affiliateCard'"
                        class="agpr-affiliates-card"
                        [disableSelection]="allSelected"
                        [entity]="outlet"
                        [selectedResults]="selectedResults"
                        (selectionChanged)="this.selectedResults = $event"
                        (showRhpTakeOver)="showRhpTakeOver.emit($event)"
                    ></agpr-affiliate-card>
                </li>
            </ul>
        </ng-container>
    </ng-container>
    <agpr-message
        *ngIf="!organizedResults || organizedResults?.length < 1"
        severity="noContent"
        [useWhiteBg]="true"
    >
        {{'Discover.targeting.rhp.tabs.affiliates.noContent' | localize}}
    </agpr-message>
</div>
